<template>
	<div>
	<div class="flex space-x-3 w-full">
		<template v-for="tab in tabs" :key="tab.name">
			<div v-if="tab.locked" @click="selectTab(tab)" :class="[tab.active ? 'bg-regal-blue-100 text-regal-blue-800' : 'hover:bg-gray-100' ,'cursor-pointer rounded-lg px-3 py-2 text-sm font-medium']">
			 	<div>{{ tab.label }}</div>
			</div>
			<div v-else class="cursor-not-allowed rounded-lg px-3 py-2 text-sm font-medium flex items-center space-x-1">
			 	<div>{{ tab.label }}</div>
			 	<div class="text-gray-700">
			 		<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
			 	</div>
			</div>
		</template>
	</div>
	<template v-for="tab in tabs">
		<div v-if="tab.active && tab.name == 'share'" class="mt-4">
			<div>
				<div class="font-bold">People with access</div>
				<div class="flex space-x-2">
					<MultiInput v-model:form="form" class="mt-1"/>
					<div class="mt-1">
		                <div @click="sendEmails" class="px-8 py-3.5 cursor-pointer hover:bg-regal-blue-800 inline-flex rounded-lg bg-regal-blue-700 text-white font-medium text-sm">
		                	Share
		                </div>
					</div>
				</div>
				<div class="space-y-1.5 overflow-y-scroll max-h-56 mt-4 -ml-1 -mr-1">
					<div v-for="user in episode.shares" class="flex items-center space-x-2 w-full group hover:bg-gray-100 rounded-full p-1">
						<div class="rounded-full w-12 h-12 group-hover:bg-gray-400 bg-gray-300 shrink-0 flex items-center justify-center text-sm font-medium text-gray-700">{{ user.email.charAt(0).toUpperCase() }}</div>
						<div class="flex items-center space-x-2 w-full">
							<div class="flex-1">
								<div class="text-sm font-medium leading-tight">{{ user.name }}</div>
							<div class="text-xs text-gray-700">{{ user.email }}</div>
							</div>
							<div @click="emit('removeShare', user.email)" class="w-12 h-12 shrink-0 rounded-full flex items-center justify-center cursor-pointer text-gray-700 hover:text-red-500">
								<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- RSS -->
		<div v-if="tab.active && tab.name == 'rss'" class="mt-4 space-y-3.5">
			<div>
				<div class="font-bold">Podcast feed</div>
				<div class="flex items-center space-x-3.5 mt-1">
					<input type="text" class="flex-1 border-gray-400 rounded-lg bg-gray-100 text-gray-700 text-sm" :value="props.episode.podcast.rssFeed" disabled>
					<div v-if="!copyingRss" @click="copyToClipboard('copyingRss', route('podcasts.feed', episode.podcast.uuid))" class="flex items-center font-medium text-sm space-x-2 px-4 py-2 rounded-md border border-gray-400 cursor-pointer hover:bg-regal-blue-100 hover:text-regal-blue-800 hover:border-transparent">
						<div><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"></path></svg></div>
						<div>Copy RSS Feed</div>
					</div>
					<div v-else class="flex items-center font-medium text-sm space-x-2 px-4 py-2 rounded-md border border-gray-400 cursor-pointer hover:bg-regal-blue-100 hover:text-regal-blue-800 hover:border-transparent">
						<div><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path></svg></div>
						<div>Copied</div>
					</div>
				</div>
		       <div class="text-sm font-medium text-gray-800 flex space-x-1 mt-1">
		           <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
		           <div class="flex items-center justify-between w-full">
		           		<div>Listeners can add this link to a podcast app of their choice</div>
		           </div>
		       </div>
	           <div class="mt-6">
	           		<div class="font-bold">Shared episodes</div>
	           		<div class="text-sm font-medium text-gray-800 flex space-x-1 mt-1">
	           			<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
	           			<div class="flex items-center justify-between w-full">
	           				<div>All shared episodes of the podcast “{{ props.episode.podcast.title }}” are added to this RSS feed</div>
	           			</div>
	           		</div>
	           		<div class="text-sm text-gray-700"></div>
	           		<div class="space-y-2 mt-3.5">
			           	<div v-for="sharedEpisode in props.episode.podcast.episodes" class="flex items-center space-x-2.5">
			           		<div class="w-12 h-12 shrink-0 rounded-md bg-cover bg-center" :style="'background-image: url(' + props.episode.image + ')'" />
			           		<div class="flex-1">
			           			<div class="text-sm font-medium leading-tight">{{ sharedEpisode.title }}</div>
			           			<div class="text-sm text-gray-700">{{ sharedEpisode.publishedAtDiff }}</div>
			           		</div>
			           		<div class="text-gray-700">
			           			<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
			           		</div>
			           	</div>
	           		</div>

	           </div>
			</div>
		</div>

		<!-- Social -->
		<div v-if="tab.active && tab.name == 'social'" class="mt-4 space-y-3.5">
			<template v-for="channel in socials">
				<a :href="channel.url" class="block">
					<div class="flex items-center justify-between border border-gray-400 rounded-lg p-3.5 space-x-3.5 group hover:bg-regal-blue-100 hover:text-regal-blue-800 cursor-pointer">
						<div class="w-12 h-12 rounded-full bg-gray-100 text-gray-700 flex items-center justify-center" v-html="channel.icon">
							
						</div>
						<div class="flex-1">
							<div class="text-sm font-medium">{{ channel.title }}</div>
							<div class="text-xs text-gray-700">{{ channel.subtitle }}</div>
						</div>
						<div>
							<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
						</div>
					</div>
				</a>
			</template>
		</div>



		<!-- Embed -->
		<div v-if="tab.active && tab.name == 'embed'" class="mt-4 space-y-3.5">
			<div class="flex space-x-3.5 items-center">
				<div class="w-32 h-32 shrink-0 rounded-md bg-cover bg-center" :style="'background-image: url(' + props.episode.image + ')'">
				</div>
				<div class="flex-1">
					<div class="text-sm text-gray-700 pt-1">{{ props.episode.podcast.title }}</div>
					<div class="font-bold text-lg">{{ props.episode.title }}</div>
					<div class="flex items-end w-full space-x-3.5">
						<div class="w-16 h-16 shrink-0 rounded-full bg-regal-blue-700 flex items-center justify-center text-white">
							<svg class="fill-current w-6 h-6 -mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 22v-20l18 10-18 10z"/></svg>
						</div>
						<div class="w-full flex-1">
					        <div class="w-full relative h-20 -mt-2.5 flex-1">
					            <div class="backdrop-saturate-0 absolute z-20 h-24" />
					            <div class="absolute bg-left bg-repeat-x bg-contain h-24 w-full z-10" :style="'background-image: url(' + asset('img/sound-waves.svg') + ')'" />
					        </div>
					        <div class="w-full flex relative justify-between text-xs font-medium text-gray-800 tracking-tight tabular-nums -mt-2">
					            <div class="">
					                0:00
					            </div>
					            <div class="">
					                {{ formatTime(props.episode.duration) }}
					            </div>
					        </div>
						</div>
					</div>
				</div>
			</div>
			<div class="w-full border-b border-b-gray-400 mt-6 mb-5"></div>
			<div class="w-full flex items-center justify-between">
				<div class="text-sm font-medium">
					Large player
					<span class="text-gray-700 font-normal text-xs">(Wider than 768px)</span>
				</div>
				<div>
                    <Switch v-model="largePlayer" :class="[largePlayer ? 'bg-regal-blue-700' : 'bg-gray-400', 'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-regal-blue-500']">
                        <span class="sr-only">Large Player</span>
                        <span aria-hidden="true" :class="[largePlayer ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition ease-in-out duration-200']" />
                    </Switch>
				</div>
			</div>
			<div class="w-full border-b border-b-gray-400 mt-6 mb-5"></div>
			<div class="flex items-center space-x-3.5">
				<input v-if="!largePlayer" type="text" class="flex-1 border-gray-400 rounded-lg bg-gray-100 text-gray-700 text-sm" :value="props.episode.embedCode.small">
				<input v-if="largePlayer" type="text" class="flex-1 border-gray-400 rounded-lg bg-gray-100 text-gray-700 text-sm" :value="props.episode.embedCode.large">
				<div v-if="!copyingCode" v-on="largePlayer ? { click: () => copyToClipboard('copyingCode', props.episode.embedCode.large) } : { click: () => copyToClipboard('copyingCode', props.episode.embedCode.small) }" class="flex items-center font-medium text-sm space-x-2 px-4 py-2 rounded-md border border-gray-400 cursor-pointer hover:bg-regal-blue-100 hover:text-regal-blue-800 hover:border-transparent">
					<div><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path></svg></div>
					<div>Copy embed code</div>
				</div>
				<div v-if="copyingCode" class="flex items-center font-medium text-sm space-x-2 px-4 py-2 rounded-md border border-gray-400 cursor-pointer hover:bg-regal-blue-100 hover:text-regal-blue-800 hover:border-transparent">
					<div><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path></svg></div>
					<div>Copied</div>
				</div>
			</div>
		</div>
	</template>
	</div>

	<div class="-mx-8 mt-6 -mb-8 bg-gray-100 p-8 pt-5 border-t border-t-gray-400">
		<div class="font-bold">General access</div>
		<div class="flex justify-between items-center mt-1">
            <div class="col-span-3">
                <select v-model="shared" @change="changeSharingOptions" name="" class="w-full rounded-lg">
                    <option :value="false">Members of {{ $page.props.auth.account.name }}</option>
                    <option :value="true">Everyone with the link</option>
                </select>
            </div>
			<div v-if="!copyingLink" @click="copyToClipboard('copyingLink', route('episodes.show', episode))" class="rounded-lg bg-gray-100 cursor-pointer flex space-x-1.5 items-center px-6 py-3.5 font-medium text-sm hover:bg-regal-blue-100 hover:text-regal-blue-800">
				<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
				<div>Copy Link</div>
			</div>
			<div v-else class="rounded-lg bg-gray-100 cursor-pointer flex space-x-1.5 items-center px-6 py-3.5 font-medium text-sm hover:bg-regal-blue-100 hover:text-regal-blue-800">
				<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path></svg>
				<div>Copied</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, defineProps, defineEmits, toRef } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import MultiInput from '@/Shared/MultiInput'
import Button from '@/Shared/Button'
import { Switch } from '@headlessui/vue'

const props = defineProps(['episode', 'auth', 'emailSharingForm'])
const emit = defineEmits(['update:emailSharingForm', 'sendEmails', 'removeShare', 'setSharing'])

const form = ref(props.emailSharingForm)

const shared = ref(props.episode.shared)
const largePlayer = ref(false)

const copyingCode = ref(false)
const copyingLink = ref(false)
const copyingRss = ref(false)

const tabs = ref([
	{
		name: 'share',
		label: 'Share',
		active: true,
		locked: true,
	},
	{
		name: 'rss',
		label: 'RSS',
		active: false,
		locked: shared.value,
	},
	{
		name: 'social',
		label: 'Social',
		active: false,
		locked: shared.value,
	},
	{
		name: 'embed',
		label: 'Embed',
		active: false,
		locked: shared.value,
	},
])

const socials = ref([
	{
		name: 'linkedin',
		label: 'LinkedIn',
		url: 'https://www.linkedin.com/sharing/share-offsite/?url=' + route('episodes.show', props.episode),
		icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-linkedin"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>',
		title: 'Share on LinkedIn',
		subtitle: 'Embed this episode in a post.'
	},
	{
		name: 'twitter',
		label: 'Twitter',
		url: 'https://twitter.com/share?text=' + encodeURIComponent(props.episode.title) + '&url=' + encodeURIComponent(route('episodes.show', props.episode)),
		icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-twitter"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>',
		title: 'Share on Twitter',
		subtitle: 'Embed this episode in a tweet.'
	},
	{
		name: 'facebook',
		label: 'Facebook',
		url: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(route('episodes.show', props.episode)),
		icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-facebook"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>',
		title: 'Share on Facebook',
		subtitle: 'Embed this episode in a post.'
	},
])

const selectTab = (tab) => {
	tabs.value.forEach(el => el.active = false)
	tabs.value.find(el => el == tab).active = true
}

const sendEmails = () => {
	emit('sendEmails')
	// emit('update:form', props.emailSharingForm)
}

const changeSharingOptions = () => {
	tabs.value.forEach(e => {
		if (e.name !== 'share') {
			e.locked = shared.value
		}
	})
	if (!shared.value) {
		selectTab(tabs.value[0])
	}
	emit('setSharing', shared.value)
}

const copyToClipboard = async (context, content) => {
	try {
		await navigator.clipboard.writeText(content).then(fn => {
			switch (context) {
			  case 'copyingLink':
				copyingLink.value = true
				setTimeout(() => {copyingLink.value = false}, 1500);
			    break
			  case 'copyingRss':
				copyingRss.value = true
				setTimeout(() => {copyingRss.value = false}, 1500);
			  	break
			  case 'copyingCode':
				copyingCode.value = true
				setTimeout(() => {copyingCode.value = false}, 1500);
			    break
			}
		})
	} catch(e) {
		console.log(e);
	}
}
</script>